module.exports = __webpack_public_path__ + "static/media/home-3.3b6898ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-3.jpg
// module id = 632
// module chunks = 0